import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className, y = 48 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
  <span className={`block overflow-hidden ${className || ""}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ChapterLabel = ({ number, text }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="font-mono-brand text-xs tracking-[0.3em] text-cyan-400 font-bold">CH.{number}</span>
    <span className="h-px w-16 bg-cyan-400/40" />
    <span className="font-mono-brand text-xs tracking-[0.3em] uppercase text-slate-400">{text}</span>
  </div>
);
